<template>
  <div>
    <div class="center ">
      <p>
        <img src="@/assets/images/main-logo-dt.png" style="height :50px; margin-top:5px;" />
      </p>
    </div>
    <v-app>
      <div class="pa-5">
        <h1
          class="mb-6"
          style="
  text-align: center; margin:20px"
        >
          Privacy Policy
        </h1>
        <div style="padding : 0px 50px 50px 50px;">
          <v-divider class="mb-16 mt-10" />
          <h1 class="mb-6">PRIVACY NOTICE</h1>
          <strong>Last updated July 11, 2025</strong>
          <span class="mt-10">
            Thank you for choosing to be part of our community at DinoTrack <strong>("Company," "we," "us," or "our")</strong>. We are
            committed to protecting your personal information and your right to privacy. If you have any questions or concerns about this privacy
            notice or our practices with regard to your personal information, please contact us at info@bts.id. <br /><br />
            By downloading the Application from the Apple AppStore, and any update thereto (as permitted by this License Agreement), You indicate that
            You agree to be bound by all of the terms and conditions of this License Agreement, and that You accept this License Agreement.
            <br /><br />
            This privacy notice describes how we might use your information if you:
            <ul>
              <li>Download and use our mobile application — DinoTrack Learning Management System</li>
              <li>Engage with us in other related ways ― including any sales, marketing, or events</li>
            </ul>
            <br />
            In this privacy notice, if we refer to:
            <ul>
              <li><b>"App,"</b> we are referring to any application of ours that references or links to this policy, including any listed above</li>
              <li><b>"Services,"</b> we are referring to our App, and other related services, including any sales, marketing, or events</li>
            </ul>
            <br />
            The purpose of this privacy notice is to explain to you in the clearest way possible what information we collect, how we use it, and what
            rights you have in relation to it. If there are any terms in this privacy notice that you do not agree with, please discontinue use of our
            Services immediately.
            <br />
            <br />
          </span>

          <h3 class="mb-6">1. WHAT INFORMATION DO WE COLLECT?</h3>
          <span>
            <strong>Personal information you disclose to us</strong><br /><br />
            <br />
            <span style="font-style :italic;"><b>In Short:</b> We collect personal information that you provide to us.</span><br /><br />
            We collect personal information that you voluntarily provide to us when you register on the App, express an interest in obtaining
            information about us or our products and Services, when you participate in activities on the App (such as by posting messages in our
            online forums or entering competitions, contests or giveaways) or otherwise when you contact us.
            <br /><br />
            The personal information that we collect depends on the context of your interactions with us and the App, the choices you make and the
            products and features you use. The personal information we collect may include the following: Personal Information Provided by You. We
            collect names; phone numbers; email addresses; usernames; passwords; debit/credit card numbers; billing addresses; and other similar
            information.
            <br /><br />
            Social Media Login Data. We may provide you with the option to register with us using your existing social media account details, like
            your Facebook, Twitter or other social media account. If you choose to register in this way, we will collect the information described in
            the section called "HOW DO WE HANDLE YOUR SOCIAL LOGINS?" below.
            <br /><br />
            All personal information that you provide to us must be true, complete and accurate, and you must notify us of any changes to such
            personal information.
            <br />
            <br />
          </span>
          <strong class="mb-6">Information automatically collected</strong><br /><br />
          <span>
            <span style="font-style :italic;"
              ><b>In Short:</b> Some information — such as your Internet Protocol (IP) address and/or browser and device characteristics — is
              collected automatically when you visit our App.</span
            ><br /><br />
            We automatically collect certain information when you visit, use or navigate the App. This information does not reveal your specific
            identity (like your name or contact information) but may include device and usage information, such as your IP address, browser and device
            characteristics, operating system, language preferences, referring URLs, device name, country, location, information about how and when
            you use our App and other technical information. This information is primarily needed to maintain the security and operation of our App,
            and for our internal analytics and reporting purposes.
            <br /><br />
            Like many businesses, we also collect information through cookies and similar technologies.
            <br /><br />
            The information we collect includes:
            <br /><br />
            <li>
              Log and Usage Data. Log and usage data is service-related, diagnostic, usage and performance information our servers automatically
              collect when you access or use our App and which we record in log files. Depending on how you interact with us, this log data may
              include your IP address, device information, browser type and settings and information about your activity in the App (such as the
              date/time stamps associated with your usage, pages and files viewed, searches and other actions you take such as which features you
              use), device event information (such as system activity, error reports (sometimes called 'crash dumps') and hardware settings).
            </li>
            <li>
              Device Data. We collect device data such as information about your computer, phone, tablet or other device you use to access the App.
              Depending on the device used, this device data may include information such as your IP address (or proxy server), device and application
              identification numbers, location, browser type, hardware model Internet service provider and/or mobile carrier, operating system and
              system configuration information.
            </li>
            <li>
              Location Data. We collect location data such as information about your device's location, which can be either precise or imprecise. How
              much information we collect depends on the type and settings of the device you use to access the App. For example, we may use GPS and
              other technologies to collect geolocation data that tells us your current location (based on your IP address). You can opt out of
              allowing us to collect this information either by refusing access to the information or by disabling your Location setting on your
              device. Note however, if you choose to opt out, you may not be able to use certain aspects of the Services.
            </li>
            <br />
            <br />
          </span>
          <strong class="mb-6">Information collected through our App</strong><br /><br />
          <span>
            <span style="font-style :italic;"
              ><b>In Short:</b> We collect information regarding your mobile device, push notifications, when you use our App.</span
            >
            <br />
            <br />
            If you use our App, we also collect the following information:<br />
            <br />
            <li>
              Mobile Device Access. We may request access or permission to certain features from your mobile device, including your mobile device's
              camera, microphone, storage, calendar, and other features. If you wish to change our access or permissions, you may do so in your
              device's settings.
            </li>
            <li>
              Push Notifications. We may request to send you push notifications regarding your account or certain features of the App. If you wish to
              opt-out from receiving these types of communications, you may turn them off in your device's settings.
            </li>
            <br />
            This information is primarily needed to maintain the security and operation of our App, for troubleshooting and for our internal analytics
            and reporting purposes
            <br />
            <br />
          </span>
          <strong class="mb-6">2. HOW DO WE USE YOUR INFORMATION?</strong><br /><br />
          <span>
            <span style="font-style :italic;"
              ><b>In Short:</b> We process your information for purposes based on legitimate business interests, the fulfillment of our contract with
              you, compliance with our legal obligations, and/or your consent.</span
            >
            <br />
            <br />
            We use personal information collected via our App for a variety of business purposes described below. We process your personal information
            for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your
            consent, and/or for compliance with our legal obligations. We indicate the specific processing grounds we rely on next to each purpose
            listed below.
            <br />
            <br />
            <li>
              We use the information we collect or receive: To facilitate account creation and logon process. If you choose to link your account with
              us to a third-party account (such as your Google or Facebook account), we use the information you allowed us to collect from those third
              parties to facilitate account creation and logon process for the performance of the contract. See the section below headed "HOW DO WE
              HANDLE YOUR SOCIAL LOGINS?" for further information.
            </li>

            <li>
              To post testimonials. We post testimonials on our App that may contain personal information. Prior to posting a testimonial, we will
              obtain your consent to use your name and the content of the testimonial. If you wish to update, or delete your testimonial, please
              contact us at __________ and be sure to include your name, testimonial location, and contact information.
            </li>

            <li>
              Request feedback. We may use your information to request feedback and to contact you about your use of our App.
            </li>

            <li>
              To enable user-to-user communications. We may use your information in order to enable user-to-user communications with each user's
              consent. To manage user accounts. We may use your information for the purposes of managing our account and keeping it in working order.
            </li>

            <li>
              To send administrative information to you. We may use your personal information to send you product, service and new feature information
              and/or information about changes to our terms, conditions, and policies. To protect our Services. We may use your information as part of
              our efforts to keep our App safe and secure (for example, for fraud monitoring and prevention).
            </li>

            <li>
              To enforce our terms, conditions and policies for business purposes, to comply with legal and regulatory requirements or in connection
              with our contract.
            </li>

            <li>
              To respond to legal requests and prevent harm. If we receive a subpoena or other legal request, we may need to inspect the data we hold
              to determine how to respond.
            </li>

            <li>
              Fulfill and manage your orders. We may use your information to fulfill and manage your orders, payments, returns, and exchanges made
              through the App.
            </li>

            <li>
              Administer prize draws and competitions. We may use your information to administer prize draws and competitions when you elect to
              participate in our competitions.
            </li>

            <li>
              To deliver and facilitate delivery of services to the user. We may use your information to provide you with the requested service.
            </li>
            <li>
              To respond to user inquiries/offer support to users. We may use your information to respond to your inquiries and solve any potential
              issues you might have with the use of our Services.
            </li>

            <li>
              To send you marketing and promotional communications. We and/or our third-party marketing partners may use the personal information you
              send to us for our marketing purposes, if this is in accordance with your marketing preferences. For example, when expressing an
              interest in obtaining information about us or our App, subscribing to marketing or otherwise contacting us, we will collect personal
              information from you. You can opt-out of our marketing emails at any time (see the "WHAT ARE YOUR PRIVACY RIGHTS?" below).
            </li>

            <li>
              Deliver targeted advertising to you. We may use your information to develop and display personalized content and advertising (and work
              with third parties who do so) tailored to your interests and/or location and to measure its effectiveness.
            </li>

            <br />
            <br />
          </span>

          <h3 class="mb-6">3. WILL YOUR INFORMATION BE SHARED WITH ANYONE?</h3>
          <div class="mb-5">
            <span style="font-style :italic;"
              ><b>In Short:</b> We only share information with your consent, to comply with laws, to provide you with services, to protect your
              rights, or to fulfill business obligations.</span
            >
            <br />
            <br />
            We may process or share your data that we hold based on the following legal basis:

            <br />
            <br />
            <li>
              Consent: We may process your data if you have given us specific consent to use your personal information for a specific purpose.
            </li>

            <li>
              Legitimate Interests: We may process your data when it is reasonably necessary to achieve our legitimate business interests.
            </li>

            <li>
              Performance of a Contract: Where we have entered into a contract with you, we may process your personal information to fulfill the terms
              of our contract. Legal Obligations: We may disclose your information where we are legally required to do so in order to comply with
              applicable law, governmental requests, a judicial proceeding, court order, or legal process, such as in response to a court order or a
              subpoena (including in response to public authorities to meet national security or law enforcement requirements).
            </li>

            <li>
              Vital Interests: We may disclose your information where we believe it is necessary to investigate, prevent, or take action regarding
              potential violations of our policies, suspected fraud, situations involving potential threats to the safety of any person and illegal
              activities, or as evidence in litigation in which we are involved.
            </li>

            <br />
            <br />
            More specifically, we may need to process your data or share your personal information in the following situations:

            <br />
            <br />
            <li>
              Business Transfers. We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company
              assets, financing, or acquisition of all or a portion of our business to another company.
            </li>

            <li>
              Affiliates. We may share your information with our affiliates, in which case we will require those affiliates to honor this privacy
              notice. Affiliates include our parent company and any subsidiaries, joint venture partners or other companies that we control or that
              are under common control with us.
            </li>

            <li>
              Business Partners. We may share your information with our business partners to offer you certain products, services or promotions.
            </li>

            <li>
              Other Users. When you share personal information or otherwise interact with public areas of the App, such personal information may be
              viewed by all users and may be publicly made available outside the App in perpetuity. If you interact with other users of our App and
              register for our App through a social network (such as Facebook), your contacts on the social network will see your name, profile photo,
              and descriptions of your activity. Similarly, other users will be able to view descriptions of your activity, communicate with you
              within our App, and view your profile.
            </li>
            <br />
          </div>

          <h3 class="mb-6">4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</h3>
          <div>
            <span style="font-style :italic;"
              ><b>In Short:</b> We may use cookies and other tracking technologies to collect and store your information.</span
            >
            <br />
            <br />
            We may use cookies and similar tracking technologies (like web beacons and pixels) to access or store information. Specific information
            about how we use such technologies and how you can refuse certain cookies is set out in our Cookie Notice.
            <br />
            <br />
          </div>
          <h3 class="mb-6">5. HOW DO WE HANDLE YOUR SOCIAL LOGINS?</h3>
          <div>
            <span style="font-style :italic;"
              ><b>In Short:</b> If you choose to register or log in to our services using a social media account, we may have access to certain
              information about you.</span
            >
            <br />
            <br />
            Our App offers you the ability to register and login using your third-party social media account details (like your Facebook or Twitter
            logins). Where you choose to do this, we will receive certain profile information about you from your social media provider. The profile
            information we receive may vary depending on the social media provider concerned, but will often include your name, email address, friends
            list, profile picture as well as other information you choose to make public on such social media platform.
            <br />
            <br />
            We will use the information we receive only for the purposes that are described in this privacy notice or that are otherwise made clear to
            you on the relevant App. Please note that we do not control, and are not responsible for, other uses of your personal information by your
            third-party social media provider. We recommend that you review their privacy notice to understand how they collect, use and share your
            personal information, and how you can set your privacy preferences on their sites and apps.
            <br />
            <br />
          </div>

          <h3 class="mb-6">6. HOW LONG DO WE KEEP YOUR INFORMATION?</h3>
          <div>
            <span style="font-style :italic;"
              ><b>In Short:</b> We keep your information for as long as necessary to fulfill the purposes outlined in this privacy notice unless
              otherwise required by law.</span
            >
            <br />
            <br />
            We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy notice, unless a
            longer retention period is required or permitted by law (such as tax, accounting or other legal requirements). No purpose in this notice
            will require us keeping your personal information for longer than .
            <br />
            <br />
            When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymize such
            information, or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will
            securely store your personal information and isolate it from any further processing until deletion is possible.
            <br />
            <br />
          </div>

          <h3 class="mb-6">7. WHAT ARE YOUR PRIVACY RIGHTS?</h3>
          <div>
            <span style="font-style :italic;"><b>In Short:</b> You may review, change, or terminate your account at any time.</span>
            <br />
            <br />

            If you are a resident in the EEA or UK and you believe we are unlawfully processing your personal information, you also have the right to
            complain to your local data protection supervisory authority. You can find their contact details here:
            https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm.

            <br />
            <br />

            If you are a resident in Switzerland, the contact details for the data protection authorities are available here:
            https://www.edoeb.admin.ch/edoeb/en/home.html.
            <br />
            <br />
          </div>
          <h3 class="mb-6">8. CONTROLS FOR DO-NOT-TRACK FEATURES</h3>
          <div>
            <span style="font-style :italic;"><b>In Short:</b> You may review, change, or terminate your account at any time.</span>
            <br />
            <br />

            If you are a resident in the EEA or UK and you believe we are unlawfully processing your personal information, you also have the right to
            complain to your local data protection supervisory authority. You can find their contact details here:
            https://ec.europa.eu/justice/data-protection/bodies/authorities/index_en.htm.

            <br />
            <br />

            If you are a resident in Switzerland, the contact details for the data protection authorities are available here:
            https://www.edoeb.admin.ch/edoeb/en/home.html.
            <br />
            <br />
            Account Information
            <br />
            <br />
            If you would at any time like to review or change the information in your account or terminate your account, you can:
            <br />
            <br />
            <li>
              Contact us using the contact information provided.
            </li>

            Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However,
            we may retain some information in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our Terms of
            Use and/or comply with applicable legal requirements.
            <br />
            <br />
            Cookies and similar technologies: Most Web browsers are set to accept cookies by default. If you prefer, you can usually choose to set
            your browser to remove cookies and to reject cookies. If you choose to remove cookies or reject cookies, this could affect certain
            features or services of our App. To opt-out of interest-based advertising by advertisers on our App visit
            http://www.aboutads.info/choices/.
            <br />
            <br />
            Opting out of email marketing: You can unsubscribe from our marketing email list at any time by clicking on the unsubscribe link in the
            emails that we send or by contacting us using the details provided below. You will then be removed from the marketing email list —
            however, we may still communicate with you, for example to send you service-related emails that are necessary for the administration and
            use of your account, to respond to service requests, or for other non-marketing purposes. To otherwise opt-out, you may:
            <br />
            <br />
            <li>
              Contact us using the contact information provided.
            </li>
            <br />
            <br />
          </div>

          <h3 class="mb-6">9. DO CALIFORNIA RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</h3>
          <div>
            <span style="font-style :italic;"
              ><b>In Short:</b> Yes, if you are a resident of California, you are granted specific rights regarding access to your personal
              information.</span
            >
            <br />
            <br />

            California Civil Code Section 1798.83, also known as the "Shine The Light" law, permits our users who are California residents to request
            and obtain from us, once a year and free of charge, information about categories of personal information (if any) we disclosed to third
            parties for direct marketing purposes and the names and addresses of all third parties with which we shared personal information in the
            immediately preceding calendar year. If you are a California resident and would like to make such a request, please submit your request in
            writing to us using the contact information provided below.

            <br />
            <br />

            If you are under 18 years of age, reside in California, and have a registered account with the App, you have the right to request removal
            of unwanted data that you publicly post on the App. To request removal of such data, please contact us using the contact information
            provided below, and include the email address associated with your account and a statement that you reside in California. We will make
            sure the data is not publicly displayed on the App, but please be aware that the data may not be completely or comprehensively removed
            from all our systems (e.g. backups, etc.).
            <br />
            <br />
          </div>

          <h3 class="mb-6">10. DO WE MAKE UPDATES TO THIS NOTICE?</h3>
          <div>
            <span style="font-style :italic;"
              ><b>In Short:</b> Yes, we will update this notice as necessary to stay compliant with relevant laws.</span
            >
            <br />
            <br />
            We may update this privacy notice from time to time. The updated version will be indicated by an updated "Revised" date and the updated
            version will be effective as soon as it is accessible. If we make material changes to this privacy notice, we may notify you either by
            prominently posting a notice of such changes or by directly sending you a notification. We encourage you to review this privacy notice
            frequently to be informed of how we are protecting your information.

            <br />
            <br />
          </div>

          <h3 class="mb-6">11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h3>
          <div>
            If you have questions or comments about this notice, you may email us at info@bts.id or by post to:
            <br /><br />
            BTS.id (Bridge Technology Services) - PT Intersolusi Teknologi Asia<br />
            Jl. Ter. Sutami I No.36, Sukagalih, Kec. Sukajadi<br />
            Kota Bandung, Jawa Barat 40163<br />
            Indonesia<br />

            <br />
            <br />
          </div>

          <h3 class="mb-6">12. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</h3>
          <div>
            Based on the applicable laws of your country, you may have the right to request access to the personal information we collect from you,
            change that information, or  delete it in some circumstances. To request to review, update, or delete your personal information

            <br />
            <br />
          </div>
        </div>
      </div>
    </v-app>
    <div class="center" style="padding:30px;">
      <strong style="color :white;">
        Copyright © 2025 DinoTrack
      </strong>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Terms',
  components: {},
  computed: {},
  data: () => ({}),
  methods: {},
  created() {}
};
</script>

<style lang="scss" scoped>
.center {
  text-align: center;
  background-color: #00BF63;
  height: 9vh;
}
</style>
